import http from "./httpServ";
// import md5 from 'blueimp-md5'
import cache from "./cacheServ";
// let alipayUrl='https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2019012163098312&scope=auth_base&redirect_uri=${}'
// if (window.location.origin.indexOf('tswap') > -1) {
//     let appid = '2021000199673518'
//     console.log('测试')2021000197667660
//     alipayUrl = 'https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021000199673518&scope=auth_user&redirect_uri=${}'
// }
class ZfbServ {
  /**
   * 获取支付宝code
   */
  getAuthCode() {
    let qrcode = this.GetQueryString("qrcode");
    let bedNo = this.GetQueryString("bedNo");
    let alipayRedirectUrl = `${window.location.origin}/static/rediurlZfb.html?qrcode=${qrcode}&bedNo=${bedNo}`;
    let alipayUrl = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=2021000199673518&scope=auth_user&redirect_uri=${encodeURIComponent(
      alipayRedirectUrl
    )}`;

    // let url = alipayUrl.replace(
    //   "${}",
    //   encodeURIComponent(alipayRedirectUrl + qrcode)
    // );
    window.location.replace(alipayUrl);
  }

  /**
   * 截取url参数
   * @param name
   * @returns {*}
   * @constructor
   */
  GetQueryString(name) {
    var after = window.location.hash.split("?")[1];
    if (after) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = after.match(reg);
    }
    if (r != null) return unescape(r[2]);
    return null;
  }

  /**
   * 支付宝支付
   * @param aliUserId
   * @param qrCode
   * @returns {Promise<U>|any|*}
   */
  postZfbPay(aliUserId, qrCode, bedNO) {
    return http.post(
      `/zfb/lease/zfbPlaceAndOrder`,
      {},
      {
        data: {
          aliUserId,
          qrCode,
          bedNO
        }
      }
    );
  }

  /**
   * 通过openid获取用户信息
   * @param openId
   * @returns {Promise<U>|any|*}
   */
  getUserInfoOpenId(openId) {
    return http.post(`/lease/queryCustomerByOpenId?openId=${openId}`);
  }

  /**
   * 芝麻信用租借
   * @param aliUserId
   * @param qrCode
   * @returns {Promise<U>|any|*}
   */
  postZmGrantFun(aliUserId, qrCode, bedNO) {
    return http.post(
      `/zfb/lease/zmGrantAuth`,
      {},
      {
        data: {
          aliUserId,
          qrCode,
          bedNO
        }
      }
    );
  }

  /**
   * 取消支付（芝麻信用）
   * @param grantOrderNo
   * @param openId
   * @param qrCode
   * @returns {any|Promise<U>|*}
   */
  postCancelZmFun(grantOrderNo, openId, qrCode, bedNo) {
    return http.post(
      `/zfb/lease/zmCancelOrder`,
      {},
      {
        data: {
          grantOrderNo,
          openId,
          qrCode,
          bedNo
        }
      }
    );
  }
}

export default new ZfbServ();



// WEBPACK FOOTER //
// ./src/service/zfbServ.js